<template>
    <c-dialog ref="dialog" width="480" title="编辑会员有效期" @resolve="saveHandle">
        <c-form ref="form" unit-width="100%">
            <c-input type="hidden" name="id"></c-input>
            <c-form-item label="会员昵称">
				<div class="j-form-text flex-start-center">
                	<span>{{memberData.nickname}}</span>
				</div>
            </c-form-item>
            <c-form-item label="手机号码">
				<div class="j-form-text flex-start-center">
                	<span>{{memberData.phone}}</span>
				</div>
            </c-form-item>
            <c-form-item label="当前有效期" v-if="memberData.vip_day">
				<div class="j-form-text flex-start-center">
					<span :class="{'expired-text': isExpired}">{{memberData.vip_day}}</span>
					<span v-if="isExpired" class="expired-tag">已过期</span>
				</div>
            </c-form-item>
            <c-form-item label="新有效期" required>
                <c-datetime name="vip_expire_date" type="datetime" format="yyyy-MM-dd hh:mm" :clear="false" placeholder="请选择有效期截止日期"></c-datetime>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
export default {
    name: 'memberVipEdit',

    data() {
        return {
            memberData: {},
            isExpired: false
        }
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            this.memberData = data || {};
            this.isExpired = this.checkExpired(this.memberData.vip_day);
            this.$refs.form.clear();
            this.$refs.form.set({
                id: this.memberData.id,
                vip_expire_date: this.memberData.vip_day ? this.memberData.vip_day : ''
            });
            this.$refs.dialog.open();
        },

        /*********判断是否过期**********/
        checkExpired(val) {
            if (!val) return false;
            let d = new Date(val);
            if (isNaN(d.getTime())) return false;
            let today = new Date();
            return d.getTime() < today.getTime();
        },

        /*********提交保存**********/
        saveHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: '/mall/member/update_vip_expire_date',
                rule: {
                    vip_expire_date: '请选择有效期截止日期'
                },
                dataFormatter: data => {
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: '编辑成功',
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
	.expired-text {
		color: #f56c6c;
	}
	.expired-tag {
		margin-left: 8px;
		color: #fff;
		background: #f56c6c;
		padding: 2px 6px;
		border-radius: 3px;
		font-size: 12px;
	}
	.j-form-text {
		height: 38px;
	}
</style>
